import {Component, OnInit} from '@angular/core';
import {CurrencyPipe} from "@angular/common";
import {MenuItem} from "primeng/api";
import {HttpStatusCode} from "@angular/common/http";
import {UtilService, CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess} from "library";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import {environment} from "projects/store/src/environments/environment";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {UserData} from "projects/store/src/app/interfaces";

@Component({
  selector: 'app-commission-list-by-brands',
  templateUrl: './commission-list-by-brands.component.html'
})
export class CommissionListByBrandsComponent implements OnInit{
  items:MenuItem[] | undefined;
  home: MenuItem | undefined;
  commissionsList: any[] = [];
  titleOfBreadcrumb = 'Comisión por marca';
  userData: UserData;

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              private currencyPipe: CurrencyPipe,
              private localStorageService: LocalStorageService,
              private utilService: UtilService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
  }

  ngOnInit() {
    this.items = [{label: 'Comisiones por teléfono'}];
    this.home = {icon: 'pi pi-home', routerLink: '/comisiones/dashboard'}
    this.load();
  }

  load() {
    this.utilService.enablePageLoading();
    this.commissionsService.getCommissionsByBrandAndPriceRange(this.userData.user.id).subscribe({
      next: (resp: ResponseHttpSuccess) => {
        if (resp.status === HttpStatusCode.Ok) {
          this.commissionsList = resp.body.data.list.sort((a: any, b:any) => this.utilService.sortByText(a.brand.name, b.brand.name));
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }

  getFormattedPriceRange(rango: any) {
    let minimo = rango.min ?? '';
    let maximo = rango.max ?? '';

    minimo = this.currencyPipe.transform(minimo, environment.global.country.currency, true, '1.0-0');
    maximo = this.currencyPipe.transform(maximo, environment.global.country.currency, true, '1.0-0');

    if (minimo && maximo) {
      return `${minimo} a ${maximo}`;
    } else if (minimo) {
      return `Mayor a ${minimo}`;
    } else if (maximo) {
      return `Menos de ${maximo}`;
    } else {
      return '';
    }
  }

  protected readonly environment = environment;
}
